import { module as BaseModule } from 'modujs';
import modular from 'modujs';
import * as themeModules from './modules';

import Lenis from '@studio-freight/lenis';

// Función helper para limpiar atributos data-module
function sanitizeModuleAttributes() {
	const elements = document.querySelectorAll('[data-module]');
	let cleaned = 0;

	elements.forEach(el => {
		const moduleName = el.getAttribute('data-module');

		// Si está vacío o solo tiene espacios
		if (!moduleName || moduleName.trim() === '') {
			console.warn('⚠️ Removiendo data-module vacío de:', el);
			el.removeAttribute('data-module');
			cleaned++;
		}
		// Si tiene espacios extras, limpiarlos
		else if (moduleName !== moduleName.trim()) {
			const cleanName = moduleName.trim();
			el.setAttribute('data-module', cleanName);
			cleaned++;
		}
	});

	return cleaned;
}

// Limpiar antes de inicializar
sanitizeModuleAttributes();

// Inicializar con manejo de errores
try {
	window.themeApp = new modular({
		modules: themeModules
	});

	window.themeApp.init(window.themeApp.modules);


} catch (error) {
}


// Inicialización mínima de Lenis
const lenis = new Lenis({
	duration: 1,
	easing: (t) => 1 - Math.pow(1 - t, 3),
	direction: 'vertical',
	smooth: true,
	smoothTouch: true,
	touchMultiplier: 2
});
window.lenis = lenis;



// Observador de clase en body para pausar/reanudar Lenis (mantener si usas .no-scroll)
const bodyObserver = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
			const hasNoScroll = document.body.classList.contains('no-scroll');
			if (hasNoScroll) {
				lenis.stop();
			} else {
				lenis.start();
			}
		}
	});
});
bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });


/* const navObserver = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		console.log(mutation);
		if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
			const hasNavOpen = nav.classList.contains('open');
			console.log(hasNavOpen);
			if (hasNavOpen) {
				lenis.stop();
			} else {
				lenis.start();
			}
		}
	});
});
navObserver.observe(document.querySelector('.theme-nav'), { attributes: true, attributeFilter: ['class'] }); */

// Maneja la clase del header según el estado de scroll
function handleHeaderScroll(lenis) {
	const headerElement = document.querySelector('header');
	if (!headerElement) return;
	const isHomepage = document.body.classList.contains('home');
	const nav = document.querySelector('.theme-nav');
	let navIsOpen = nav?.classList.contains('open');
	if (!isHomepage && !navIsOpen) {
		lenis.on('scroll', (e) => {
			headerElement.classList.toggle('up', !!e.__isScrolling);
		});
	}
}

// Manejo de enlaces ancla para scroll suave
function handleAnchorLinks(lenis) {
	window.addEventListener('hashchange', () => {
		if (window.location.hash) {
			smoothScrollToAnchor(window.location.hash, lenis);
		}
	});
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', (event) => {
			event.preventDefault();
			const targetId = anchor.getAttribute('href');
			smoothScrollToAnchor(targetId, lenis);
		});
	});
}

function initScroll(lenis) {
	handleHeaderScroll(lenis);
	handleAnchorLinks(lenis);
}

// RAF loop para Lenis y lazySizes si está presente
function raf(time) {
	lenis.raf(time);
	if (window.lazySizes && window.lazySizes.loader) {
		window.lazySizes.loader.checkElems();
	}
	requestAnimationFrame(raf);
}

// Observa cambios de tamaño del contenedor de scroll para redimensionar Lenis
function observeScrollContainer(lenis) {
	// El scroll puede estar ligado a <html> en algunos navegadores, así que
	// observamos ambos (body + html) y el elemento de scroll real.
	const scrollEl = document.scrollingElement || document.documentElement;
	const targets = [document.body, document.documentElement, scrollEl].filter(Boolean);

	const resizeObserver = new ResizeObserver(() => {
		lenis.resize();
	});

	targets.forEach((element) => resizeObserver.observe(element));

	// En ciertos casos el contenido se carga/añade mientras se hace scroll
	// (lazy-load, imágenes, etc.). Si cambia la altura del documento, forzamos
	// un resize para que Lenis recalibre su tamaño interno.
	let prevScrollHeight = document.documentElement.scrollHeight;
	lenis.on('scroll', () => {
		const scrollHeight = document.documentElement.scrollHeight;
		if (scrollHeight !== prevScrollHeight) {
			prevScrollHeight = scrollHeight;
			lenis.resize();
		}
	});

	// También recalcular al redimensionar la ventana o cambiar la orientación.
	window.addEventListener('resize', () => lenis.resize(), { passive: true });
}

// Scroll suave hacia un anchor (usa Lenis)
function smoothScrollToAnchor(anchor, lenis) {
	if (!anchor) return;
	const targetElement = document.querySelector(anchor);
	if (targetElement) {
		// Para accesibilidad: mover el foco al destino del ancla.
		// Esto hace que el skip link funcione correctamente con teclado/lectores de pantalla.
		try {
			targetElement.focus({ preventScroll: true });
		} catch (e) {
			// Fallback para navegadores sin preventScroll.
			try { targetElement.focus(); } catch (e2) { /* noop */ }
		}

		const headerHeight = document.querySelector('header')?.offsetHeight || 0;
		const scrollY = window.scrollY || window.pageYOffset || 0;
		const targetPosition = targetElement.getBoundingClientRect().top + scrollY;
		lenis.scrollTo(targetPosition - headerHeight, {
			duration: 2.5,
			easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
		});
	}
}

function initOnLoad() {
	initScroll(lenis);
	observeScrollContainer(lenis);
	requestAnimationFrame(raf);
}

// Inicialización al cargar DOM
document.addEventListener('DOMContentLoaded', function () {
	if (window.location.hash) {
		const targetId = window.location.hash.substring(1);
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			// Temporalmente quitar hash y hacer scroll suave con retardo
			window.history.replaceState(null, null, ' ');
			setTimeout(() => {
				smoothScrollToAnchor(`#${targetId}`, lenis);
				window.history.replaceState(null, null, `#${targetId}`);
			}, 2000);
		}
	}

	// Accessibility fix: make button-like anchors without href focusable
	document.querySelectorAll('.wp-block-button__link').forEach(el => {
		if (!el.hasAttribute('href')) {
			el.setAttribute('tabindex', '0');
			if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
		}
	});

	// Accessibility: make mini-cart drawer inert when closed to prevent focusable elements from being reachable
	function handleMiniCartInert() {
		const FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';

		function inertify(drawer) {
			if (!drawer) return;
			const focusables = drawer.querySelectorAll(FOCUSABLE);
			// Try to set native inert when available (best-effort)
			if (typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype) {
				try { drawer.inert = true; } catch(e) { /* noop */ }
			} else {
				drawer.setAttribute('inert', '');
			}
			// Always force tabindex=-1 on focusable descendants so axe and older browsers see them as non-focusable
			focusables.forEach(el => {
				const prev = el.getAttribute('tabindex');
				if (prev !== null) el.setAttribute('data-prev-tabindex', prev);
				el.setAttribute('tabindex', '-1');
			});
			drawer.setAttribute('data-inertified', 'true');
		}

		function deinertify(drawer) {
			if (!drawer) return;
			// Remove native inert if present
			if (typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype) {
				try { drawer.inert = false; } catch (e) { /* noop */ }
			} else {
				drawer.removeAttribute('inert');
			}
			if (!drawer.hasAttribute('data-inertified')) return;
			// Restore previous tabindex values when available, otherwise remove tabindex so element returns to default focus behaviour
			const focusables = drawer.querySelectorAll('[tabindex="-1"]');
			focusables.forEach(el => {
				const prev = el.getAttribute('data-prev-tabindex');
				if (prev !== null) {
					el.setAttribute('tabindex', prev);
					el.removeAttribute('data-prev-tabindex');
				} else {
					el.removeAttribute('tabindex');
				}
			});
			drawer.removeAttribute('data-inertified');
		}

		function processDrawer(drawer) {
			if (!drawer) return;
			const ariaHidden = drawer.getAttribute('aria-hidden');
			if (ariaHidden === 'true' || drawer.classList.contains('is-hidden')) {
				inertify(drawer);
			} else {
				deinertify(drawer);
			}
		}

		const observed = new WeakSet();
		function observe(drawer) {
			if (!drawer || observed.has(drawer)) return;
			observed.add(drawer);
			processDrawer(drawer);
			const mo = new MutationObserver((mutations) => {
				for (const m of mutations) {
					if (m.type === 'attributes' && (m.attributeName === 'aria-hidden' || m.attributeName === 'class')) {
						processDrawer(drawer);
					}
				}
			});
			mo.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
		}

		// Observe existing and future drawers
		document.querySelectorAll('.wc-block-mini-cart__drawer').forEach(observe);
		const bodyObserver = new MutationObserver(mutations => {
			for (const m of mutations) {
				m.addedNodes?.forEach(node => {
					if (node.nodeType === 1) {
						if (node.matches('.wc-block-mini-cart__drawer')) observe(node);
						node.querySelectorAll && node.querySelectorAll('.wc-block-mini-cart__drawer').forEach(observe);
					}
				});
			}
		});
		bodyObserver.observe(document.body, { childList: true, subtree: true });
	}

	// initialize mini-cart inert handling
	handleMiniCartInert();

	initOnLoad();
});
